export default __webpack_public_path__ + "static/tiffany-a3793d087c6acfa5511551391435c787.jpg";